export enum LoginAuthType {
  Google = "Google",
  Microsoft = "Microsoft",
  SSO = "SSO",
  Username = "Username",
  Phone = "Phone",
  Email = "Email",
}

export const passwordAuthTypes = new Set([
  LoginAuthType.Email,
  LoginAuthType.Phone,
  LoginAuthType.Username,
]);
